<template>
  <div>
    <div class="container-fluid" style="zoom: 80%">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h3 style="font-weight:700">Account Settings</h3>
        </div>
        <Sidebar />
        <div class="col-md-10 pl-0" v-if="status">
          <div
            class="card card-box mb-3 "
            style="border-radius : 0%; height: 97.5%;"
          >
            <div class="card-body">
              <b-form>
                <div class="row">
                  <div class="col-md-12 mt-2 mb-3">
                    <h4 class="__blue" style="font-weight: 700">
                      Integrasi SatuSehat
                    </h4>
                  </div>
                  <div class="col-md-8">
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Organization ID:"
                      label-for="organization-id"
                    >
                      <b-input-group>
                        <template #append>
                          <b-input-group-text
                            :class="btnDisable ? 'disabled' : ''"
                            @click="
                              !btnDisable
                                ? (passwordVisible3 = !passwordVisible3)
                                : true
                            "
                          >
                            <svg
                              v-if="passwordVisible3 == false"
                              xmlns="http://www.w3.org/2000/svg"
                              height="1em"
                              viewBox="0 0 640 512"
                            >
                              <path
                                d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                              />
                            </svg>
                            <!-- <font-awesome-icon
                              v-if="passwordVisible3 == false"
                              :icon="['fas', 'eye-slash']"
                            /> -->
                            <font-awesome-icon v-else :icon="['fas', 'eye']" />
                          </b-input-group-text>
                        </template>
                        <b-form-input
                          id="organization-id"
                          :disabled="btnDisable"
                          placeholder="Tulis Organization ID"
                          v-model="form.organization_id"
                          :type="passwordVisible3 ? 'text' : 'password'"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Client Key:"
                      label-for="client-id"
                    >
                      <b-input-group>
                        <template #append>
                          <b-input-group-text
                            :class="btnDisable ? 'disabled' : ''"
                            @click="
                              !btnDisable
                                ? (passwordVisible = !passwordVisible)
                                : true
                            "
                          >
                            <svg
                              v-if="passwordVisible == false"
                              xmlns="http://www.w3.org/2000/svg"
                              height="1em"
                              viewBox="0 0 640 512"
                            >
                              <path
                                d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                              />
                            </svg>
                            <!-- <font-awesome-icon
                              v-if="passwordVisible == false"
                              :icon="['fas', 'eye-slash']"
                            /> -->

                            <font-awesome-icon v-else :icon="['fas', 'eye']" />
                          </b-input-group-text>
                        </template>
                        <b-form-input
                          id="client-id"
                          :disabled="btnDisable"
                          placeholder="Tulis Client Key"
                          v-model="form.client_id"
                          :type="passwordVisible ? 'text' : 'password'"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="4"
                      content-cols-sm
                      content-cols-lg="8"
                      label="Secret Key:"
                      label-for="client-secret"
                    >
                      <b-input-group>
                        <template #append>
                          <b-input-group-text
                            :class="btnDisable ? 'disabled' : ''"
                            @click="
                              !btnDisable
                                ? (passwordVisible2 = !passwordVisible2)
                                : true
                            "
                          >
                            <svg
                              v-if="passwordVisible2 == false"
                              xmlns="http://www.w3.org/2000/svg"
                              height="1em"
                              viewBox="0 0 640 512"
                            >
                              <path
                                d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                              />
                            </svg>
                            <!-- <font-awesome-icon
                              v-if="passwordVisible2 == false"
                              :icon="['fas', 'eye-slash']"
                            /> -->
                            <font-awesome-icon v-else :icon="['fas', 'eye']" />
                          </b-input-group-text>
                        </template>
                        <b-form-input
                          id="client-secret"
                          :disabled="btnDisable"
                          placeholder="Tulis Secret Key"
                          v-model="form.client_secret"
                          :type="passwordVisible2 ? 'text' : 'password'"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col-md-12 mt-5 mb-3">
                    <b-button
                      variant="success"
                      v-if="!btnDisable"
                      class="float-right"
                      @click="onSubmit"
                      >SIMPAN</b-button
                    >
                    <b-button
                      variant="primary"
                      v-if="btnDisable"
                      @click="btnDisable = false"
                      class="float-right"
                      >EDIT DATA</b-button
                    >
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="__modal_loading"
      hide-header
      hide-footer
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none modal_loading"
      size="xs"
    >
      <b-row>
        <b-col sm="12" class="text-center">
          <div class="spinner-border text-warning mb-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p>
            Mohon Menunggu <br />
            Sedang melakukan proses konfigurasi
          </p>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    Sidebar: () => import("@/views/AccountSettingKlinik/Sidebar")
  },
  data: () => {
    return {
      passwordVisible: false,
      passwordVisible2: false,
      passwordVisible3: false,
      status: true,
      btnDisable: true,
      form: {
        organization_id: null,
        client_id: null,
        client_secret: null
      }
    };
  },
  mounted() {
    this.fetchData();
    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  methods: {
    onSubmit() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger mr-2"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Apakah Anda yakin akan melakukan<br>Integrasi SatuSehat?</p>',
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          reverseButtons: true
        })
        .then(res => {
          if (res.value) {
            this.btnDisable = true;
            this.submit();
          }
        });
    },
    async submit() {
      try {
        const res = await this.$axios.put(
          `satu-sehat/auth?klinik_id=${this.getKlinikId}`,
          this.form
        );
        const { status } = res.data;
        if (status) {
          this.$store.commit("SET_SATUSEHAT_AUTH_VALID", 1);
          this.$swal({
            type: "success",
            html:
              '<p class="m-0 text-bridging-bpjs">Integrasi SatuSehat berhasil</p>',
            customClass: {
              confirmButton: "btn btn-success"
            },
            buttonsStyling: false
          });
        } else {
          this.btnDisable = false;
          this.$swal({
            type: "warning",
            html:
              '<p class="m-0 text-bridging-bpjs">Integrasi SatuSehat gagal! <br> Mohon cek kembali data konfigurasi SatuSehat</p>',
            customClass: {
              confirmButton: "btn btn-success"
            },
            buttonsStyling: false
          });
        }
      } catch (error) {
        this.$swal({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Integrasi SatuSehat gagal! <br> Mohon cek kembali data konfigurasi SatuSehat</p>',
          customClass: {
            confirmButton: "btn btn-success"
          },
          buttonsStyling: false
        });
      }
    },
    async fetchData() {
      try {
        const res = await this.$axios.get(
          `satu-sehat/auth?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          if (data.satusehat_auth_valid) {
            this.form.organization_id = data.satusehat_organization_id;
            this.form.client_id = data.satusehat_client_id;
            this.form.client_secret = data.satusehat_client_secret;
          }
          this.status = true;
        }
      } catch (e) {
        // console.log(e);
      }
    }
  }
};
</script>

<style>
.col-form-label {
  margin-bottom: 20px;
}
.text-bridging-bpjs {
  font-size: 14px;
  font-weight: 600;
}
.modal_loading .modal-header {
  background-color: #ffffff;
}
.modal-backdrop {
  opacity: 0.5 !important;
}
</style>

<style scoped>
.__blue {
  color: #4b80b6;
}
.alert {
  border-radius: 5px;
}
.alert-radio-label {
  padding: 0.75rem 2rem;
  margin-right: 50px;
}
.alert-bridging-bpjs {
  background-color: #eeeff8;
  opacity: 1;
  top: -10px;
}
.p-bridging-bpjs {
  margin: 0;
}
.spinner-border {
  width: 5em;
  height: 5em;
}

.input-group-text {
  background-color: transparent;
}

.input-group-text.disabled {
  background-color: #eeeff8;
}
</style>
